
import GridContainer from './GridContainer';
import GridItem from './GridItem';
import GridGroup from './GridGroup';

GridContainer.Item = GridItem;
GridContainer.Group = GridGroup;

export default GridContainer;